export const NOTICE_REQUEST = 'NOTICE_REQUEST';
export const NOTICE_SUCCESS = 'NOTICE_SUCCESS';
export const NOTICE_FAIL    = 'NOTICE_FAIL';

